module.exports = __webpack_public_path__ + "static/media/mark.4c9d21e8.svg";